/**
 * Created by Rene Lopez on 31/10/16.
 */

// PersonalDetailsView.js

import $ from 'jquery';
import _ from 'lodash';
import {Model} from 'backbone';
import BasePropertyView from 'BasePropertyView.js';
import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';
import eventBus from 'EventBus.js';
import listService      from 'ListService.js';
import DashboardModel   from 'DashboardModel.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/personal-details-view.ejs';
import SimpleConfirmModal from 'common-views/SimpleConfirmModalView.js';
import CountryList from 'CountryList.js';
import USStates from 'USStates.js';
import CAProvinces from 'CAStates.js';
import zLib                 from 'util/ZLib';
import util from 'util/Util.js';
import userService      from 'UserService.js';
import undoService from 'UndoService.js'
import textConstants from 'TextConstants';

class PersonalDetailsView extends BasePropertyView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.events = {
            'change select[name=Title],select[name=LanguageISO],select[name=StateProvince]': 'changeDropdownValue',
            'change select[name=CountryISO]': 'processCountrySelection',
            'change input[type=text],input[type=password]':'processInputTexts',
            'blur input[type=text], input[type=password]'   : 'lostFocus',
            'focus input[type=text], input[type=password]'  : 'getFocus',
            'change input[type=checkbox]':'manageCheckboxes',
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=cancelChanges]': 'cancelChanges',
            'click #goToSettings': 'goToSettings',
            'click #goToPersonalSettings': 'goToPersonalSettings'
        };

        this.listenTo(this.model, 'change', this.render);
        this.selectedField = null;

        return this;
    }

    changeDropdownValue(ev) {
        console.log(ev);
        console.log("Entered to Manage Dropdowns");
        let currentModel = this.model.get('currentPersonalDetails');
        const propName = ev.currentTarget.name;
        currentModel[propName] = ev.currentTarget.value.toLowerCase();
        this.model.set('currentPersonalDetails', currentModel, {silent: true});
        this.model.set('hasChanges', true, {silent: true});
        this.render();
    }

    manageCheckboxes(ev) {
        console.log(ev);
        console.log("Entered to Manage Checkboxes");
        let currentModel = this.model.get('currentPersonalDetails');
        const propName = ev.currentTarget.name;
        currentModel[propName] = ev.currentTarget.checked;

        if(propName === 'GettingStarted') {
          listService.userSettings.set('_maShGS', ev.currentTarget.checked);
        }


        this.model.set('currentPersonalDetails', currentModel, {silent: true});
        this.model.set('hasChanges', true, {silent: true});
        this.render();
    }

    processInputTexts(ev){
        console.log("Entered to Process InputTexts");
        let currentModel = this.model.get('currentPersonalDetails');
        const propName = ev.currentTarget.name;
        currentModel[propName] = ev.currentTarget.value;

        this.selectedField = propName;

        this.model.set('currentPersonalDetails', currentModel, {silent: true});
        this.model.set('hasChanges', true, {silent: true});
        this.render();
    }

    processCountrySelection(event) {
        let userDetails = this.model.get('currentPersonalDetails');
        let stateProvinceDropdown = $(`select[name='StateProvince']`);
        switch (event.target.value) {
            case 'US':
                let usStateOptions = USStates.getStatesList().map((state)=> {
                    return $(`<option value='${state.value}'>${state.caption}</option>`);
                });
                stateProvinceDropdown.prop('disabled', false);
                stateProvinceDropdown.empty();
                stateProvinceDropdown.append(usStateOptions);
                break;
            case 'CA':
                let caProvinceOptions = CAProvinces.getProvincesList().map((province)=> {
                    return $(`<option value='${province.value}'>${province.caption}</option>`);
                });
                stateProvinceDropdown.prop('disabled', false);
                stateProvinceDropdown.empty();
                stateProvinceDropdown.append(caProvinceOptions);
                break;
            default:
                stateProvinceDropdown.empty();
                stateProvinceDropdown.prop('disabled', true);
                userDetails.StateProvince = '';
        }

        const propName = event.currentTarget.name;
        userDetails[propName] = event.currentTarget.value.toLowerCase();
        this.model.set('currentPersonalDetails', userDetails, {silent: true});
        this.model.set('hasChanges', true, {silent: true});
        this.render();
    }

    updateDropdowns(userDetails){

        $(`option[value="${userDetails.Title}"]`).prop('selected', true);

        this.fillCountries();
        if (userDetails.CountryISO) {
            if (userDetails.CountryISO === 'us') {
                this.fillUSStates();
            }
            else if (userDetails.CountryISO === 'ca') {
                this.fillCanadianProvinces();
            }
            else {
                // If not Canada or EU is chosen, disable state dropdown.
                $(`select[name="StateProvince"]`).prop('disabled', true);
            }
            // If there is an State/Province on the model select it.
            if (userDetails.StateProvince) {
                $(`select[name="StateProvince"] option[value='${userDetails.StateProvince.toUpperCase()}']`).prop('selected', true);
            }
            // Selecting the Country from the model.
            $(`select[name="CountryISO"] option[value='${userDetails.CountryISO.toUpperCase()}']`).prop('selected', true);
        }
    }

    fillCountries(){
        let countryOptions = CountryList.getCountryList().map((country)=> {
            return $(`<option value='${country.value}'>${country.caption}</option>`);
        });
        $('select[name="CountryISO"]').append(countryOptions);
    }

    fillUSStates(){
        let usStateOptions = USStates.getStatesList().map((state)=> {
            return $(`<option value='${state.value}'>${state.caption}</option>`);
        });
        $('select[name="StateProvince"]').append(usStateOptions);
    }

    fillCanadianProvinces(){
        let caProvinceOptions = CAProvinces.getProvincesList().map((province)=> {
            return $(`<option value='${province.value}'>${province.caption}</option>`);
        });
        $('select[name="StateProvince"]').append(caProvinceOptions);
    }

    cancelChanges() {
        console.log('Canceling Changes');
        this.model.set('currentPersonalDetails',Object.assign({},this.model.get('personalDetails')),{silent:true});
        this.model.set('hasChanges',false);
        this.render();
    }

    validateData(){
        let currentModel = this.model.get('currentPersonalDetails');
        if((currentModel.newPassword || currentModel.currentPassword || currentModel.repeatPassword)){
               if(currentModel.newPassword.length < 6){
                   NotificationService.error("The 'new password' must be at least 6 characters long.");
                   return false;
               }
               else if(currentModel.newPassword !== currentModel.repeatPassword){
                   NotificationService.error(`The 'new password' and 'repeat password' do not match.Enter the same password in both fields.`);
                   return false;
               }
              return true;
        }
        if(currentModel.EmailAddress) {
            if (!util.validateEmail(currentModel.EmailAddress)) {
                NotificationService.error(`The Email address provided is in an incorrect format. The Email address is required.`);
                return false
            }
        }


        if(currentModel.AlternateEmailAddress){
            if(!util.validateEmail(currentModel.AlternateEmailAddress)) {
                NotificationService.error(`The Alternate email address provided is in an incorrect format. The Email address is required.`);
                return false
            }
        }

            return true;
    }

    applyChanges() {
        let currentModel = this.model.get('currentPersonalDetails');
        
        if(!this.validateData()) {
            return;
        } 

        const newDetails = this.getPersonalSettingsDTO(currentModel)
        const oldDetails = this.getPersonalSettingsDTO(Object.assign({},this.model.get('personalDetails')))

        undoService.add({
            undo: ()=> {
                this.persistChanges(oldDetails)
            },
            redo: () => {
                this.persistChanges(newDetails)
            }
        }, textConstants.UNDO_UPDATE_PERSONAL_DETAILS);

        this.persistChanges(newDetails);
    }

    persistChanges(params){
        console.log('Params before Saving', params);
        RestService.updatePersonalDetails(params).then((updateResponse)=> {
            console.log('Updated Response', updateResponse);
            eventBus.trigger(constants.EV_UPDATE_PERSONAL_DETAILS);
        }).catch((err=> {
            if(err.CODE === '1') {
                console.log(`An error has occurred.The e-mail and password combination is not recognized.`, err);
                NotificationService.error('An error has occurred.The e-mail and password combination is not recognized.' + err.MESSAGE);
            }
            else{
                console.log('Error while updating personal details', err);
                NotificationService.error('Error while updating updating personal details' + err.MESSAGE);
            }
        }));
    }

    getPersonalSettingsDTO(model){
        return {
            userId:this.model.get('userId'),
            title: model.Title,
            firstName: model.FirstName,
            lastName: model.LastName,
            oldPassword:model.oldPassword,
            newPassword: model.newPassword,
            emailAddress: model.EmailAddress,
            addressLine1: model.AddressLine1,
            addressLine2: model.AddressLine2,
            town: model.Town,
            zipCode: model.ZipCode,
            stateProvince: model.StateProvince || constants.DEFAULT_GROUP_ID,
            countryISO: model.CountryISO,
            telephone: model.Telephone,
            cellPhone: model.Cellphone,
            fax: model.Fax,
            skype: model.Skype,
            alternateEmailAddress: model.AlternateEmailAddress,
            languageISO: model.LanguageISO,
            customId: model.CustomId,
            settingsXML: zLib.compressForm(userService.populateUserSettingsFromApp())
        };
    }

    render() {
        const html = this.template( this.model.toJSON() );

        $(this.$el[0]).html( html );

        const currentPersonalDetails = this.model.get('currentPersonalDetails');
        console.log('New User Details', currentPersonalDetails);

        let gettingStarted = util.isTrue(currentPersonalDetails['GettingStarted']);
        $(`input[name='GettingStarted']`).prop('checked', gettingStarted );

        let KeepLogged = util.isTrue(currentPersonalDetails['KeepLogged']);
        $(`input[name='KeepLogged']`).prop('checked', KeepLogged );

        this.updateDropdowns(currentPersonalDetails);

        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        if (this.selectedField && $('input[name="' + this.selectedField +'"]')) {
            $('input[name="' + this.selectedField +'"]').focus().val("").val(this.model.get('currentPersonalDetails')[this.selectedField]);
        }

        return this;
    }

    refresh(){
        if(this.model.get('hasChanges')){            
            let simpleModal=new SimpleConfirmModal({
                model:new Model({subtitle:`Personal Details`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_PERSONAL_DETAILS);
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_PERSONAL_DETAILS);
        }  
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToPersonalSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_5"]').click();
    }
}

export default PersonalDetailsView;

